import React from 'react'
import { withRouter } from 'react-router-dom'
import {
  Button,
  Col,
  Row,
  Table,
  Message,
  Modal,
  Form,
  Input,
  Radio,
} from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
// import './style.css'
import {
  getStores,
  getStoreType,
  getStoreArea,
  newOrEditStore,
  getStoreDetail,
  deleteStore,
  getUnbindingTable,
} from '../../../api/businessCommodity'

class Categories extends React.Component {
  state = {
    club_id: '',
    storeList: [],
    storeTypeList: [],
    storeAreaList: [],
    areaIds: [],
    isVisible: false,
    confirmLoading: false,
    title: '',
    name: '',
    storeType: 1,
    modalState: '',
    unBindingTable: [],
    originUnbingTable: [],
  }

  componentDidMount() {
    this.getStoreTypeList()
    // this.getStoreAreaList()
    this.getStoreList()
    this.getUnbindTables()
  }

  getUnbindTables = async () => {
    const club_id = sessionStorage.getItem('club_id')
    const { data, status, detail } = await getUnbindingTable(club_id)
    if (status != 1) {
      Message.error(detail)
      return
    }
    this.setState({ originUnbingTable: data })
    data &&
      data.map((item, index) => {
        item.isOn = false
      })
    this.setState({ storeAreaList: data })
  }

  // 获取仓库类型列表
  getStoreTypeList = async () => {
    const { data, status, detail } = await getStoreType()
    if (status == 1) {
      data.forEach((item) => {
        if (item.description) {
          item.label = item.description
        }
      })
      this.setState({ storeTypeList: data })
    } else {
      Message.error(detail)
    }
  }

  // 获取销售区域列表
  getStoreAreaList = async () => {
    const { data, status, detail } = await getStoreArea()
    if (status == 1) {
      data &&
        data.map((item, index) => {
          item.isOn = false
        })
      this.setState({ storeAreaList: data })
    } else {
      Message.error(detail)
    }
  }

  // 获取仓库列表
  getStoreList = async () => {
    const club_id = sessionStorage.getItem('club_id')
    const { data, status, detail } = await getStores(club_id)
    if (status == 1) {
      this.setState({ storeList: data })
    } else {
      Message.error(detail)
    }
  }

  // 获取仓库数据
  getStoreData = async (id) => {
    const { data, status, detail } = await getStoreDetail(id)
    if (status == 1) {
      let areaList = this.state.storeAreaList
      let tables = data.tables
      tables &&
        tables.map((item, index) => {
          item.isOn = true
        })
      areaList = areaList.concat(tables)

      this.setState({
        name: data.store.name,
        storeType: data.store.type,
        storeAreaList: areaList,
      })
    } else {
      Message.error(detail)
    }
  }

  // 模态窗确定按钮
  onOk = async () => {
    if (this.state.name) {
      this.setState({ confirmLoading: true })
      const club_id = sessionStorage.getItem('club_id')
      const areaIds = []
      this.state.storeAreaList &&
        this.state.storeAreaList.map((item, index) => {
          if (item.isOn == true) {
            areaIds.push(item.id)
          }
        })
      const params = {
        store: {
          clubId: club_id,
          name: this.state.name,
          type: this.state.storeType,
        },
        tableIds: areaIds,
      }
      if (this.state.modalState == 'modify') {
        params.store.id = this.state.selectId
      }
      const { data, status, detail } = await newOrEditStore(params)
      if (status == 1) {
        Message.success('操作成功')
        this.getStoreList()
        this.getUnbindTables()
        this.setState({ confirmLoading: false })
        this.onCancel()
        // this.setState({ isVisible: false })
      } else {
        Message.error(detail)
        this.setState({ confirmLoading: false })
      }
    } else {
      Message.error('请完整填写信息')
      this.setState({ confirmLoading: false })
    }
  }

  // 模态窗关闭
  onCancel = () => {
    const areaList = this.state.storeAreaList
    areaList &&
      areaList.map((item, index) => {
        item.isOn = false
      })
    this.setState({
      isVisible: false,
      name: '',
      areaIds: [],
      storeAreaList: areaList,
      storeType: 1,
      selectId: '',
    })
  }

  // 打开模态窗
  showModal = (title, record) => {
    if (!record) {
      this.setState({
        title: title,
        isVisible: true,
        modalState: 'new',
      })
    } else {
      this.getStoreData(record.id)
      this.setState({
        modalState: 'modify',
        isVisible: true,
        selectId: record.id,
      })
    }
  }

  // 仓库种类切换
  typeChange = ({ target: { value } }) => {
    this.setState({ storeType: value })
  }

  // 销售区域切换
  earaHandle = (index) => {
    const areaList = this.state.storeAreaList
    areaList[index].isOn = !areaList[index].isOn
    this.setState({ storeAreaList: areaList })
  }

  // 删除仓库
  deleteCategory = async (id) => {
    const ids = []
    ids.push(id)
    const { data, status, detail } = await deleteStore({ ids: ids })
    if (status == 1) {
      Message.success('删除成功')
      this.getStoreList()
    } else {
      Message.error(detail)
    }
  }

  modalClose = () => {
    this.setState({ storeAreaList: this.state.originUnbingTable })
  }

  // 遍历所有区域全选或非全选
  mapAllArea = (flag) => {
    let area = this.state.storeAreaList
    area.map((item, index) => {
      item.isOn = flag
    })
    this.setState({ storeAreaList: area })
  }

  selectAllArea = () => {
    if (!this.state.storeAreaList) {
      return
    }

    let isOnCount = 0
    this.state.storeAreaList.length > 0 &&
      this.state.storeAreaList.map((item, index) => {
        if (item.isOn) {
          isOnCount++
        }
      })

    if (isOnCount == 0 || isOnCount < this.state.storeAreaList.length) {
      this.mapAllArea(true)
    }
    if (isOnCount == this.state.storeAreaList.length) {
      this.mapAllArea(false)
    }

    // if (this.state.storeAreaList) {
    //   let area = this.state.storeAreaList
    //   area.map((item, index) => {
    //     item.isOn = true
    //   })
    //   this.setState({ storeAreaList: area })
    // }
  }

  render() {
    const { areaIds } = this.state
    const columns = [
      {
        title: '仓库id',
        dataIndex: 'id',
      },
      {
        title: '仓库名称',
        dataIndex: 'name',
      },
      {
        title: '仓库类型',
        dataIndex: 'type',
        render: (text, record, index) => {
          return (
            <div>
              {this.state.storeTypeList.map((item, index) => {
                if (item.value == text) {
                  return item.description
                }
              })}
            </div>
          )
        },
      },
      {
        title: '操作',
        dataIndex: 'handle',
        render: (text, record, index) => {
          return (
            <div>
              <Button
                size="small"
                type="primary"
                style={{ marginRight: '20px' }}
                onClick={() => {
                  this.showModal('编辑分类', record)
                }}
              >
                编辑
              </Button>

              <Popconfirm
                title="确认要删除此仓库？"
                onConfirm={() => {
                  this.deleteCategory(record.id)
                }}
                okText="是"
                cancelText="否"
              >
                <Button size="small" type="danger">
                  删除
                </Button>
              </Popconfirm>
            </div>
          )
        },
      },
    ]

    return (
      <div>
        <Row>
          <Col span={12}>
            <Button
              type="primary"
              onClick={() => {
                this.showModal('添加仓库')
              }}
            >
              添加仓库
            </Button>
          </Col>
        </Row>
        <Table
          bordered
          style={{ marginTop: '30px' }}
          size="small"
          pagination={false}
          dataSource={this.state.storeList}
          columns={columns}
          rowKey="id"
        />

        <Modal
          visible={this.state.isVisible}
          title={this.state.title}
          onOk={this.onOk}
          onCancel={this.onCancel}
          confirmLoading={this.state.confirmLoading}
          afterClose={this.modalClose}
          // width="800px"
          // destroyOnClose="true"
        >
          <Form.Item
            style={{ marginBottom: '40px' }}
            label={
              <span>
                <span className="color_red">* </span>
                <span>仓库名称</span>
              </span>
            }
          >
            <Row gutter={8}>
              <Col span={20}>
                <Input
                  value={this.state.name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                  placeholder="请输入仓库名称"
                />
              </Col>
            </Row>
          </Form.Item>

          <Form.Item
            label={
              <span>
                <span className="color_red">* </span>
                <span>仓库类型</span>
              </span>
            }
          >
            <Row gutter={8}>
              <Col span={20}>
                <Radio.Group
                  options={this.state.storeTypeList}
                  onChange={this.typeChange}
                  value={this.state.storeType}
                  optionType="button"
                  buttonStyle="solid"
                />
                <div style={{ color: '#ccc' }}>（请选择一种类型）</div>
              </Col>
            </Row>
          </Form.Item>

          <Form.Item
            label={
              <span>
                <span className="color_red">* </span>
                <span>销售区域</span>
                <span style={{ marginLeft: '10px' }}>
                  <Button
                    type="primary"
                    size="small"
                    onClick={this.selectAllArea}
                  >
                    全选
                  </Button>
                </span>
              </span>
            }
          >
            <Row gutter={8}>
              <Col span={20}>
                <div>
                  {this.state.storeAreaList.map((item, index) => {
                    return (
                      <Button
                        type={item.isOn ? 'primary' : 'dashed'}
                        style={{ marginRight: '10px', marginBottom: '6px' }}
                        key={item.id}
                        onClick={() => {
                          this.earaHandle(index)
                        }}
                      >
                        {item.name}
                      </Button>
                    )
                  })}
                </div>
                <div style={{ color: '#ccc' }}>
                  （请选择一项或多项销售区域）
                </div>
              </Col>
            </Row>
          </Form.Item>
        </Modal>
      </div>
    )
  }
}
export default withRouter(Categories)



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/Stories/index.js